/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientBehaviorDataModel } from '../../models/patient-behavior-data-model';

export interface SavePatientBehaviorData$Params {
  addedManually?: boolean;
      body?: PatientBehaviorDataModel
}

export function SavePatientBehaviorData(http: HttpClient, rootUrl: string, params?: SavePatientBehaviorData$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientBehaviorDataModel>> {
  const rb = new RequestBuilder(rootUrl, SavePatientBehaviorData.PATH, 'post');
  if (params) {
    rb.query('addedManually', params.addedManually, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PatientBehaviorDataModel>;
    })
  );
}

SavePatientBehaviorData.PATH = '/api/Staff/SavePatientBehaviorData';
